import { getConfig } from '@app/config';
import { createQueryParamString, initEmptyItemList } from '@app/utils/util';
import { CompactKeywordSet, ItemList, KeywordSet } from '@store/domain';
import { get, writable } from 'svelte/store';

/* Store for fetching & storing keywords (keywords don't often change, could save in localStorage etc.) */

export const activityKeywordSetList = writable<ItemList<KeywordSet>>(initEmptyItemList<KeywordSet>());
export const eventKeywordSetList = writable<ItemList<KeywordSet | CompactKeywordSet>>(initEmptyItemList<KeywordSet>());
export const selectedEventKeywords = writable<Array<string>>([]);
export const isLoadingEventKeywords = writable<boolean>(false);
export const isLoadingActivityKeywords = writable<boolean>(false);
export const selectedActivityKeyword = writable<string>('');

export function loadEventKeywords() {
  if (!get(isLoadingEventKeywords)) {
    isLoadingEventKeywords.set(true);
    console.log('Loading event keywords...');
    eventKeywordSetList.set({
      meta: {
        count: 16,
        next: null,
        previous: null
      },
      data: [
        {
          usage: 'audience',
          keywords: [
            { name: { fi: 'Aikuiset', sv: '', en: '' }, id: 'yso:p5590' },
            { name: { fi: 'Harrastajat', sv: '', en: '' }, id: 'yso:p10699' },
            { name: { fi: 'Ikäihmiset', sv: '', en: '' }, id: 'yso:p2434' },
            { name: { fi: 'Lapset ja lapsiperheet', sv: '', en: '' }, id: 'yso:p4354' },
            { name: { fi: 'Nuoret', sv: '', en: '' }, id: 'yso:p11617' },
            { name: { fi: 'Opiskelijat', sv: '', en: '' }, id: 'yso:p16486' },
            { name: { fi: 'Yritykset', sv: '', en: '' }, id: 'yso:p1178' },
            { name: { fi: 'Yhdistykset', sv: '', en: '' }, id: 'yso:p1393' }
          ]
        },
        {
          usage: 'keyword',
          keywords: [
            { id: 'yso:p16327', name: { fi: 'Elokuva', sv: '', en: '' } },
            { id: 'yso:p2901', name: { fi: 'Harrastukset', sv: '', en: '' } },
            { id: 'yso:p17710', name: { fi: 'Hengelliset', sv: '', en: '' } },
            { id: 'yso:p22036,yso:p2762', name: { fi: 'Hyvinvointi ja terveys', sv: '', en: '' } },
            { id: 'yso:p84,yso:p7765', name: { fi: 'Koulutukset ja seminaarit', sv: '', en: '' } },
            { id: 'yso:p2739', name: { fi: 'Kuvataide', sv: '', en: '' } },
            { id: 'yso:p318,yso:p6062', name: { fi: 'Leikit ja pelit', sv: '', en: '' } },
            { id: 'yso:p916,yso:p965', name: { fi: 'Liikunta ja urheilu', sv: '', en: '' } },
            { id: 'yso:p4892,yso:p24062', name: { fi: 'Messut ja markkinat', sv: '', en: '' } },
            { id: 'yso:p4934', name: { fi: 'Museot', sv: '', en: '' } },
            { id: 'yso:p1808', name: { fi: 'Musiikki', sv: '', en: '' } },
            { id: 'yso:p5121', name: { fi: 'Näyttely', sv: '', en: '' } },
            { id: 'yso:p368,yso:p5127', name: { fi: 'Ruoka ja juomat', sv: '', en: '' } },
            { id: 'yso:p1278,yso:p3046', name: { fi: 'Tanssi', sv: '', en: '' } },
            { id: 'yso:p2625', name: { fi: 'Teatteri', sv: '', en: '' } },
            {
              id: 'yso:p1178,yso:p3128,yso:p1181',
              name: { fi: 'Yritystapahtumat', sv: '', en: '' }
            }
          ]
        }
      ]
    });
    isLoadingEventKeywords.set(false);
  }
  // const { baseUrl } = getConfig().api;
  // const { events } = getConfig().modules;
  // if (!get(isLoadingEventKeywords)) {
  //   isLoadingEventKeywords.set(true);
  //   console.log('Loading event keywords...');

  //   const params = createQueryParamString(events.keywordSets ? events.keywordSets.queryParams : {});
  //   const url = `${baseUrl}/${events.apiPath}/keyword_set/?${params}`;
  //   console.log(url);

  //   fetch(url)
  //     .then(res => res.json())
  //     .then(res => {
  //       eventKeywordSetList.set(res);
  //       isLoadingEventKeywords.set(false);
  //     })
  //     .catch(err => {
  //       console.error(err);
  //       isLoadingEventKeywords.set(false);
  //     });
  // }
}

export function loadActivityKeywords() {
  const { baseUrl } = getConfig().api;
  const { activities } = getConfig().modules;
  if (!get(isLoadingActivityKeywords)) {
    isLoadingActivityKeywords.set(true);
    console.log('Loading activity keywords...');

    const params = createQueryParamString(activities.keywordSets ? activities.keywordSets.queryParams : {});
    const url = `${baseUrl}/${activities.apiPath}/keyword_set/?${params}`;
    console.log(url);

    fetch(url)
      .then(res => res.json())
      .then(res => {
        activityKeywordSetList.set(res);
        isLoadingActivityKeywords.set(false);
      })
      .catch(err => {
        console.error(err);
        isLoadingActivityKeywords.set(false);
      });
  }
}

export function toggleSelectedEventKeyword(keywordId: string) {
  const keywords = get(selectedEventKeywords);
  const foundKeyword = keywords.find((k: string) => k === keywordId);
  if (foundKeyword) {
    selectedEventKeywords.set(keywords.filter((k: string) => k !== foundKeyword));
  } else {
    keywords.push(keywordId);
    selectedEventKeywords.set(keywords);
  }
}
